import React from 'react';
import Grid from '@material-ui/core/Grid';
import { StatsItem } from 'features/command-center';
import { useStyles } from 'features/command-center/components/shared';
import { useFeatureFlags } from 'providers/FeatureFlagsProvider';
import strings from 'strings';
import { FPCard } from 'UI/components/atoms/FPCard';
import { FeatureFlags } from 'UI/constants/featureFlags';
import { currencyFormatter } from 'UI/utils';

export const ProductionBoardWidgets = ({
  widgetsValues: { mtdProduction, mtdTracking, ytdProduction, ytdTracking }
}) => {
  const classes = useStyles();
  const { checkIfFeatureFlagEnabled } = useFeatureFlags();
  const showTracking = checkIfFeatureFlagEnabled(FeatureFlags.CommandCenterProductionBoardTracking);

  const items = [
    {
      loading: mtdProduction === undefined,
      title: strings.commandCenter.productionBoard.widgets.mtdProduction,
      valueColor: 'black',
      value: currencyFormatter(mtdProduction),
      isVisible: true
    },
    {
      loading: ytdProduction === undefined,
      title: strings.commandCenter.productionBoard.widgets.ytdProduction,
      valueColor: 'black',
      value: currencyFormatter(ytdProduction),
      isVisible: true
    },
    {
      loading: mtdTracking === undefined,
      title: strings.commandCenter.productionBoard.widgets.mtdTracking,
      valueColor: 'green',
      value: currencyFormatter(mtdTracking),
      isVisible: showTracking
    },
    {
      loading: ytdTracking === undefined,
      title: strings.commandCenter.productionBoard.widgets.ytdTracking,
      valueColor: 'green',
      value: currencyFormatter(ytdTracking),
      isVisible: showTracking
    }
  ];

  return items
    .filter(item => item.isVisible)
    .map(item => (
      <Grid key={item.title} item xs={showTracking ? 3 : 6}>
        <FPCard>
          <div className={classes.widgetContainer}>
            <StatsItem size="large" {...item} />
          </div>
        </FPCard>
      </Grid>
    ));
};
